import { render, staticRenderFns } from "./facilitatorCourse.vue?vue&type=template&id=4e8dc6ae&scoped=true&"
import script from "./facilitatorCourse.vue?vue&type=script&lang=js&"
export * from "./facilitatorCourse.vue?vue&type=script&lang=js&"
import style0 from "./facilitatorCourse.vue?vue&type=style&index=0&id=4e8dc6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8dc6ae",
  null
  
)

export default component.exports